<template lang="pug">
div#options-tabs-super-container.tabs-super-container
  .box-shadow-container.left.box-shadow-container-options-left(v-show="showLeftShadow")
    img.chevron(:src="'/img/icons/left-chevron-' + mode +  '.svg'", alt="Scroll left")
  .tabs-container#coin-filter-container(
    :style="'max-width: ' + tabsContainerMaxWidth + 'px'"
  )
    .tabs.filter-label
      .coin-filter(v-for="o, index in listOfCoins", @click="select(o)", :class="{'selected': o.active}")
        span {{o.coin}}
        img(:src="o.logo", :alt="o.coin + ' logo'")
  .box-shadow-container.right.box-shadow-container-options-right(v-show="showRightShadow")
    img.chevron(:src="'/img/icons/right-chevron-' + mode +  '.svg'", alt="Scroll right")
</template>

<script>
export default {
  name: 'c_coin_filter',
  props: ['listOfCoins'],
  data() {
    return {
      showLeftShadow: false,
      showRightShadow: false,
      tabsContainerMaxWidth: 0,
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      horizontalScroll: false,
      isHoveringLeft: false,
      isHoveringRight: false,
      lateralPadding: 1.5 * 16 * 2, // 48
      scrollMovement: 10
    }
  },
  computed: {
    mode() {
      return this.$store.getters.mode
    }
  },
  mounted() {
    let vm = this
    let tabsContainer = document.getElementById('coin-filter-container')
    tabsContainer.addEventListener('scroll', vm.reprintShadowScroll)
    window.addEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-options-left')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-options-right')[0]

    boxShadowScrollLeft.addEventListener('click', (e) => {
      vm.isHoveringRight = false
      vm.isHoveringLeft = true
      // vm.doScroll('left', vm.scrollMovement * 8)
      let itemsInContainer = tabsContainer.querySelectorAll('.tabs .coin-filter');
      let currentScrollPos = tabsContainer.scrollLeft;
      let newPos = (currentScrollPos - tabsContainer.offsetWidth);
      let offsetPos = 0;

      for (let itemInContainer of [...itemsInContainer].reverse()) {
        if (itemInContainer.offsetLeft < newPos) {
          offsetPos = newPos - itemInContainer.offsetLeft + 25
          break;
        }
      }

      tabsContainer.scrollTo({
        top: 0,
        left: newPos - offsetPos,
        behavior: 'smooth'
      })
      vm.isHoveringLeft = false
    });

    boxShadowScrollLeft.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringRight = false
        vm.isHoveringLeft = true
        vm.doScroll('left', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.addEventListener('mouseout', (e) => {
      vm.isHoveringLeft = false
    });

    boxShadowScrollRight.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringLeft = false
        vm.isHoveringRight = true
        vm.doScroll('right', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.addEventListener('mouseout', (e) => {
      vm.isHoveringRight = false
    });

    boxShadowScrollRight.addEventListener('click', (e) => {
      vm.isHoveringLeft = false
      vm.isHoveringRight = true
      // vm.doScroll('right', vm.scrollMovement * 8)
      let itemsInContainer = tabsContainer.querySelectorAll('.tabs .coin-filter');
      let currentScrollPos = tabsContainer.scrollLeft;
      let newPos = (currentScrollPos + tabsContainer.offsetWidth);
      let offsetPos = 0;

      for (let itemInContainer of [...itemsInContainer]) {
        if (itemInContainer.offsetLeft > newPos) {
          offsetPos = newPos - itemInContainer.offsetLeft + 25
          break;
        }
      }

      tabsContainer.scrollTo({
        top: 0,
        left: newPos - offsetPos,
        behavior: 'smooth'
      })
      vm.isHoveringRight = false
    });

    tabsContainer.addEventListener('mousedown', (e) => {
      vm.lastTimeDown = +new Date();
      vm.isDown = true;
      vm.startX = e.pageX - tabsContainer.offsetLeft;
      vm.scrollLeft = tabsContainer.scrollLeft;
    });
    tabsContainer.addEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    tabsContainer.addEventListener('mouseup', () => {
      let itemsInContainer = tabsContainer.querySelectorAll('.tabs .coin-filter');
      for (let itemInContainer of [...itemsInContainer]) {
        itemInContainer.style.pointerEvents = null;
      }
      vm.isDown = false;
    });
    tabsContainer.addEventListener('mousemove', (e) => {
      if (vm.lastTimeDown && vm.lastTimeDown > +new Date() - 100) return
      if (!vm.isDown) return;
      e.preventDefault();
      let itemsInContainer = tabsContainer.querySelectorAll('.tabs .coin-filter');
      for (let itemInContainer of [...itemsInContainer]) {
        itemInContainer.style.pointerEvents = 'none';
      }
      vm.isHoveringLeft = false
      vm.isHoveringRight = false
      const x = e.pageX - tabsContainer.offsetLeft;
      const walk = (x - vm.startX) * 1; // scroll-normal
      tabsContainer.scrollLeft = vm.scrollLeft - walk;
    });

    // Excecute after mounted
    setTimeout(function () {
      vm.reprintShadowScroll()
    }, 100)
  },
  unmounted() {
    let vm = this
    let tabsContainer = document.getElementById('coin-filter-container')
    tabsContainer.removeEventListener('scroll', vm.reprintShadowScroll)
    window.removeEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-options-left')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-options-right')[0]

    boxShadowScrollLeft.removeEventListener('click', (e) => {
      vm.isHoveringRight = false
      vm.isHoveringLeft = true
      vm.doScroll('left', vm.scrollMovement * 8)
      vm.isHoveringLeft = false
    });

    boxShadowScrollLeft.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringRight = false
        vm.isHoveringLeft = true
        vm.doScroll('left', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.removeEventListener('mouseout', (e) => {
      vm.isHoveringLeft = false
    });

    boxShadowScrollRight.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringLeft = false
        vm.isHoveringRight = true
        vm.doScroll('right', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.removeEventListener('mouseout', (e) => {
      vm.isHoveringRight = false
    });

    boxShadowScrollRight.removeEventListener('click', (e) => {
      vm.isHoveringLeft = false
      vm.isHoveringRight = true
      vm.doScroll('right', vm.scrollMovement * 8)
      vm.isHoveringRight = false
    });

    tabsContainer.removeEventListener('mousedown', (e) => {
      vm.isDown = true;
      vm.startX = e.pageX - tabsContainer.offsetLeft;
      vm.scrollLeft = tabsContainer.scrollLeft;
    });
    tabsContainer.removeEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    tabsContainer.removeEventListener('mouseup', () => {
      vm.isDown = false;
    });
    tabsContainer.removeEventListener('mousemove', (e) => {
      if (!vm.isDown) return;
      e.preventDefault();
      vm.isHoveringLeft = false
      vm.isHoveringRight = false
      const x = e.pageX - tabsContainer.offsetLeft;
      const walk = (x - vm.startX) * 1; // scroll-normal
      tabsContainer.scrollLeft = vm.scrollLeft - walk;
    });
  },
  beforeDestroy() {
    let vm = this
    window.removeEventListener('resize', vm.reprintShadowScroll);
  },
  methods: {
    select(o) {
      let vm = this
      // let tabsContainer = document.getElementById('coin-filter-container')
      // tabsContainer.scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // })
      if (!vm.isDown) vm.$emit('selected', o.coin)
    },
    reprintShadowScroll(e) {
      let vm = this
      let tabsContainer = document.getElementById('coin-filter-container')

      let container = document.getElementById('options-tabs-super-container')
      vm.tabsContainerMaxWidth = container.clientWidth

      if (tabsContainer.clientWidth === 0) {
        setTimeout(function () {
          vm.reprintShadowScroll()
        }, 100)
      } else {
        if (tabsContainer.scrollWidth - tabsContainer.clientWidth === 0) {
          // There is no scroll
          vm.showLeftShadow = false
          vm.showRightShadow = false
          vm.horizontalScroll = false
        } else {
          if (tabsContainer.scrollLeft !== 0) vm.showLeftShadow = true
          else vm.showLeftShadow = false

          if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) vm.showRightShadow = false
          else vm.showRightShadow = true

          vm.horizontalScroll = true
        }
      }
    },
    doScroll(direction, amount) {
      let vm = this

      if (vm.isHoveringLeft && vm.isHoveringRight) {
        if (direction === 'left') vm.isHoveringRight = false
        if (direction === 'right') vm.isHoveringLeft = false
      }

      let tabsContainer = document.getElementById('coin-filter-container')

      if (tabsContainer.scrollLeft === 0) {
        vm.isHoveringLeft = false
      } else if ((tabsContainer.scrollWidth - tabsContainer.clientWidth) - tabsContainer.scrollLeft < 1.1) {
        vm.isHoveringRight = false
      }

      if (vm.isHoveringLeft || vm.isHoveringRight) {
        let leftScroll = tabsContainer.scrollLeft
        if (direction === 'left') leftScroll = tabsContainer.scrollLeft - amount
        else leftScroll = tabsContainer.scrollLeft + amount

        if (leftScroll < 0) leftScroll = 0

        tabsContainer.scrollTo({
          top: 0,
          left: leftScroll,
          behavior: 'smooth'
        })

        setTimeout(function () {
          if (vm.isHoveringLeft && vm.isHoveringRight) {
            if (direction === 'left') vm.isHoveringRight = false
            if (direction === 'right') vm.isHoveringLeft = false
          }
          if (vm.isHoveringLeft && direction === 'left') vm.doScroll(direction, amount)
          if (vm.isHoveringRight && direction === 'right') vm.doScroll(direction, amount)
        }, 50)
      }
    },
    isTouchEvent() {
      return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
  }
}
</script>

<style lang="stylus" scoped>
.tabs-super-container
  margin-bottom 16px
  overflow: hidden;
  overflow-x: hidden;
  position relative
  border-bottom 0px
  position relative

.box-shadow-container
  width 20px
  height 100%
  position absolute
  z-index: 10;
  display flex
  align-items center
  padding 5px
  cursor pointer
  -webkit-tap-highlight-color: transparent;
  &.left
    top 1px
    left 0px
    box-shadow: inset 12px 0px 14px -13px #000;
  &.right
    top 1px
    right 0
    box-shadow: inset -8px 0px 14px -13px #000;

.tabs-container
  position relative
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width 100%
  overflow-x: auto;
  overflow-y: hidden;
  position relative
  scrollbar-width: none;
  
.tabs
  justify-content: flex-start
  font-size 16px
  font-weight 400
  overflow-x hidden
  border-bottom 0px
  margin-bottom 0px

.animated-circle
  content: ''; 
  height: 10px; 
  width: 10px; 
  display: inline-block; 
  border-radius: 50%; 
  margin-left: 5px;
  animation: 5s rotate linear infinite;
  background: linear-gradient(var(--angle), #d8ff58, #80ecb7);
  cursor pointer
      

html.dark, body.dark
  .box-shadow-container
    &.left
      box-shadow: inset 16px 0px 13px -13px #fff;
    &.right
      box-shadow: inset -12px 0px 13px -13px #fff;
  .tabs
    .coin-filter
      color #fff
      &.selected
        background #fff
        border-color: #fff
        color #000
      a
        &:hover
          color: #fff;
        
.tabs-container::-webkit-scrollbar {
    display none
}

img.chevron
  user-drag: none;  
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;

.tag-referral
  margin-left: -12px;
  margin-right: 16px;
  background-color: #72CBB2;
  color: white;
  font-weight: bold;

.filter-label
  span
    font-size 13px
  .coin-filter
    padding: 2px 8px 2px 10px;
    display: inline-block;
    cursor: pointer;
    font-weight: 400;
    // font-size: 12px;
    // box-shadow: 0 0 1px #3f3f3f;
    margin: 5px;
    border-radius: 5px;
    font-size: 0.7rem;
    cursor: pointer;
    margin-left: 5px;
    color: #717171;
    background-color: transparent;
    border-color: #e5e5e5;
    border-style: solid;
    border-width: 1px;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &.selected
      border-color: #717171;
      font-weight: 700;
    img, span
      display inline-block
      vertical-align middle
    span
      margin-right 5px
    img
      max-width: inherit;
      width 15px
      vertical-align middle
</style>



// WEBPACK FOOTER //
// c_coin_filter.vue?098643e8